<template>
  <h3 class="section-header"><slot /></h3>
</template>

<script>
  export default {
    name: 'SectionHeader'
  };
</script>

<style lang="scss">
  @import '../../styles/mixins.scss';

  .section-header {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 40px;
    text-align: center;
    color: var(--section-header-color);

    @include mdScreen() {
      text-align: left;
    }

    @include lgScreen() {
      font-size: 36px;
    }
  }
</style>
